import type { I18nTranslate } from '@openx/types/translations.ts';

import { getPercentageValue } from './getPercentageValue.ts';

export const getReductionFactorLabel = (
  t: I18nTranslate,
  monthly_requests?: number | null,
  requests_without_targeting?: number | null
): string => {
  const reductionFactorCalculated =
    monthly_requests && requests_without_targeting ? monthly_requests / requests_without_targeting : null;

  return reductionFactorCalculated !== null ? `${getPercentageValue(reductionFactorCalculated)}%` : t('N / A');
};
